import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import { prepareFilters } from '../../../../components/Filters/request';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item.regular_user,
      key: item.regular_user.uuid,
      creator: {
        uuid: item.regular_user.uuid,
        avatar_url: item.regular_user.avatar_url,
        avatar_params: item.regular_user.avatar_params,
        name: item.regular_user.name,
        social_accounts: item.regular_user.social_accounts,
        connection_id: item.id
      },
      links: item.lifetime_links,
      clicks: item.lifetime_clicks,
      sales: item.lifetime_gmv,
      last_link_shared: item.last_link_shared,
      campaigns: item.top_campaigns,
      groups: item.top_groups,
      connection_id: item.id,
      select: { id: item.regular_user.uuid, value: false },
      operations: item.regular_user
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getMyCreatorsConnected({ payload: { signal, filters, searchQ, exclude, curr_page } }) {
  try {

    const sort = prepareFilters(filters).sort;

    const { data } = yield call(fetch, {
      api: api.unmasking.connections.search,
      // params: {
      //   page: curr_page,
      //   ...(searchQ && { q: searchQ }),
      //   ...(sort && { ordering: sort[0] })
      // },
      data: {
        page: curr_page,
        // ...prepareFilters(filters),
        ...(searchQ && { q: searchQ }),
        ...(sort && { sort: sort[0] }),
        ...(exclude && { exclude_uuids: exclude })
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getMyCreatorsConnectedDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getMyCreatorsConnectedFailed,
      endpoint: api.unmasking.connections.search.url
    });
  }
}

export const getMyCreatorsConnectedSaga = takeEvery(types.GET_MY_CREATORS_CONNECTED_REQUEST, getMyCreatorsConnected);